<template>
<template v-if="!loading&&TCP">
  <div class="w-full flex flex-col gap-2"> 
    <div class="grid grid-cols-4 sm:grid-cols-4 lg:grid-cols-5 gap-2">
    <MiniaturaCastell v-for="item in TCP.castells.filter(Boolean)" :universitaria="true" :key=item :castell="item.castell" :novetat="item.estrena" class="drop-shadow-sm"/>
    </div>
    <h3 class="text-base">Posició <a href="https://sigac.cat/barometre" class="text-red-600 hover:text-red-400 hover:underline" target="_blank">Baròmetre Universitari</a>: <span class="rounded px-1 text-lg px-2 drop-shadow" :class="TCP.posicio<9? mapaPosicio[TCP.posicio] : mapaPosicio[9]">{{ TCP.posicio }}</span></h3>
    <a href='https://sigac.cat'              
        class="p-1 hover:bg-gray-300 bg-gray-200 hover:underline rounded-full w-fit flex items-center"
        >

                         <div class="w-10 h-10  mr-2"><img :src="logoSigac" alt="Logotip SiGAC" class="rounded-full"  target="_blank"/></div>
                        <p>Dades provinents del SiGAC</p>
        <font-awesome-icon :icon="['fas', 'arrow-up-right-from-square']" class="p-2"/></a>
  </div>
</template>
<template v-else-if="!loading&&TCP===null"><div class="bg-gray-200 w-full rounded h-28 flex items-center justify-center">
  <img :src="logoSigacB" alt="Logotip SiGAC" class="w-10 h-10 mr-2 brightness-0 opacity-60"/>
  <p class="text-black/60">
    <font-awesome-icon :icon="['fas', 'exclamation-triangle']" class="text-red-600/100 text-lg"/> No s'ha pogut connectar amb el SiGAC...</p></div></template>
<template v-else><div class="bg-gray-200 w-full rounded h-28 animate-pulse flex items-center justify-center">
  <img :src="logoSigacB" alt="Logotip SiGAC" class="w-10 h-10 mr-2 brightness-0 opacity-60"/>
  <p class="opacity-60">
    Connectant amb el SiGAC...</p></div></template>


</template>
<script setup async>
import { ref, onMounted,defineProps } from 'vue'
//import castell from '@/functions/notacioCastell.js';
import logoSigac from '@/assets/sigac_color.png'
import logoSigacB from '@/assets/sigac_blanc.png'

const loading=ref(true)
const sigapi = ref(null)
const TCP = ref(null)
const ApiSigac = 'https://sigac.cat/api/barometre?token=aleta-test'

const props = defineProps({
colla:{
  type:String,
  required:true
}
}
)

onMounted(async()=>{
   try {const api = await fetch(ApiSigac)
  const parsedapi = await api.json()
  console.log('API Sigac Correcte')
  sigapi.value = parsedapi
  console.log(sigapi.value.find(c=>c.colla==mapaId[props.colla]))
  TCP.value=sigapi.value.find(c=>c.colla==mapaId[props.colla])
  console.log(TCP.value)
} 
catch(e){ 
  console.error('Error API Sigac:', e)
}
finally {
    loading.value = false
  }


} 

)

const mapaId={
    "bergants_del_campus_de_terrassa":"Bergants",
    "xoriguers_de_la_udg":"Xoriguers",
    "engrescats_de_la_url":"Engrescats",
    "los_marracos_de_la_udl":"Marracos",
    "arreplegats_de_la_zona_universitaria":"Arreplegats",
    "descargolats_de_l_eebe":"Descargolats",
    "emboirats_de_la_uvic":"Emboirats",
    "gambirots_de_la_uib":"Gambirots",
    "ganapies_de_la_uab":"Ganàpies",
    "grillats_del_cbl":"Grillats",
    "llunatics_de_la_upc_de_vilanova":"Llunàtics",
    "passerells_del_tecnocampus":"Passerells",
    "pataquers_de_la_urv":"Pataquers",
    "penjats_del_campus_de_manresa":"Penjats",
    "trempats_de_la_upf":"Trempats",
  }

const mapaPosicio={
  1:"bg-grup-7 text-white",
  2:"bg-grup-6 text-white",
  3:"bg-grup-5 text-white",
  4:"bg-grup-4 text-white",
  5:"bg-grup-3 text-white",
  6:"bg-grup-2 text-black",
  7:"bg-grup-1 text-black",
  8:"bg-grup-0 text-black",
  9:"bg-white text-black"
}

</script>
